export const getRatingColor = (value: string|number|null|undefined) => {
  if (value === null || value === undefined || value === "") {
    return "color-mix(in srgb, var(--text), transparent 35%)";
  }
  const rating = Number(value);
  if (!Number.isFinite(rating)) {
    return "color-mix(in srgb, var(--text), transparent 35%)";
  }
  if (rating < 3) return "#e53935";
  if (rating < 6) return "#f98e3f";
  if (rating < 8) return "#ffd60a";
  return "#20bf6b";
};

export const getRatingToneClass = (value: string|number|null|undefined) => {
  if (value === null || value === undefined || value === "") {
    return "rating-value rating-value--empty";
  }
  const rating = Number(value);
  if (!Number.isFinite(rating)) return "rating-value rating-value--empty";
  if (rating < 3) return "rating-value rating-value--low";
  if (rating < 6) return "rating-value rating-value--mid";
  if (rating < 8) return "rating-value rating-value--good";
  return "rating-value rating-value--great";
};
